(function ($) {
    var ResultFilter = function (element, options) {
        let settings = $.extend({
            url: null,
            urlRemove: null
        }, options || {});

        /*
         * Public method
         * Can be called outside class
         */
        this.capture = function () {
            let timer = null;
            let isRequesting = false;
            let msg = null;

            $('input.filter-query').on('keyup', function () {
                let $input = $(this);

                clearTimeout(timer);

                timer = setTimeout(function () {
                    if (!isRequesting) {
                        $.ajax({
                            url: settings.url,
                            type: "GET",//request is a POSt request
                            dataType: "json",//expect json as return
                            data: {query: $input.val()},
                            beforeSend: function (jqXHR, settings) {
                                isRequesting = true;

                                msg = Messenger().post({
                                    message: 'Loading...',
                                    type: 'info',
                                    showCloseButton: true,
                                    hideAfter: 2,
                                    hideOnNavigate: true,
                                    id: '1'
                                });

                                //$input.siblings('i.fa').removeClass('fa-search').addClass('ico ico-small ico-spinner');
                            },
                            success: function (result) //trigger this on success
                            {
                                isRequesting = false;

                                //$input.siblings('i.fa').removeClass('ico ico-small ico-spinner').addClass('fa-search');

                                if (result.success) {
                                    msg.update({message: result.message, type: 'success'});

                                    $('#' + $input.data('target')).html(result.html);
                                } else {
                                    msg.update({message: result.message, type: 'error'});
                                }
                            }
                        });
                    }
                }, 500);
            });

            // ajax submit filter
            $(function () {
                let options = {
                    dataType: 'json',
                    //target:        '#ajax-form-container',
                    beforeSubmit: function () {
                        //$('#btn-add-cart').button('loading');
                        msg = Messenger().post({
                            message: 'Updating...',
                            type: 'info',
                            showCloseButton: true,
                            hideAfter: 2,
                            hideOnNavigate: true,
                            id: '1'
                        });

//         	    $('#cart-review').css('opacity', 0.5);
                    },
                    complete: function () {
                        //console.info('complete');
                    },
                    success: function (result, status) {
//             	$('#cart-review').css('opacity', 1);

                        if (result.success) {
                            msg.update({message: result.message, type: 'success'});

                            buildFilterTags($('.filter-tags ul.list-inline').empty(), result.filter_tags);

                            $('#' + $('input.filter-query').data('target')).html(result.html);

                            $('.page-filter .dropdown-toggle').dropdown('toggle');

                        } else {
                            msg.update({message: result.message, type: 'error'});
                        }
                    }
                    //timeout:   3000
                };

                $('form.form-filter').ajaxForm(options);
            });

            $('#container').on('click', '.filter-tags span.close', function (e) {
                let $tag = $(this).closest('span.tag-name');

                $.ajax({
                    url: settings.urlRemove,
                    type: "GET",//request is a POSt request
                    dataType: "json",//expect json as return
                    data: {k: $tag.data('id')},
                    beforeSend: function (jqXHR, settings) {
                        msg = Messenger().post({
                            message: 'Loading...',
                            type: 'info',
                            showCloseButton: true,
                            hideAfter: 2,
                            hideOnNavigate: true,
                            id: '1'
                        });

                        //$input.siblings('i.fa').removeClass('fa-search').addClass('ico ico-small ico-spinner');
                    },
                    success: function (result) {
                        //$input.siblings('i.fa').removeClass('ico ico-small ico-spinner').addClass('fa-search');
                        if (result.success) {
                            $tag.closest('.page-filter').find('form #' + $tag.data('id')).val('');

                            $tag.closest('li.tag').remove();

                            msg.update({message: result.message, type: 'success'});

                            $('#' + $('input.filter-query').data('target')).html(result.html);
                        } else {
                            msg.update({message: result.message, type: 'error'});
                        }
                    }
                });
            });

            $('#container').on('click', 'ul.filter-dropdown', function (event) {
                event.stopPropagation();
            });

            $('.input-daterange').datepicker({
                format: "yyyy-mm-dd",
                //autoclose: true,
                todayHighlight: true,
                templates: {
                    leftArrow: '<i class="fas fa-angle-left"></i>',
                    rightArrow: '<i class="fas fa-angle-right"></i>'
                }
            }).on('hide', function(e) {
            });

            $('.date-picker input').datepicker({
                format: "yyyy-mm-dd",
                todayHighlight: true,
                autoclose: true,
                templates: {
                    leftArrow: '<i class="fas fa-angle-left"></i>',
                    rightArrow: '<i class="fas fa-angle-right"></i>'
                }
            });

            $('.month-picker input').datepicker({
                format: "M yyyy",
                startView: "months",
                minViewMode: "months",
                autoclose: true,
                templates: {
                    leftArrow: '<i class="fas fa-angle-left"></i>',
                    rightArrow: '<i class="fas fa-angle-right"></i>'
                }
            });
        };

        this.filterWithReload = function () {
            $('#container').on('click', '.filter-tags span.close', function (e) {
                let $tag = $(this).closest('span.tag-name');

                window.location.href = `${settings.urlRemove}?k=${$tag.data('id')}`;

                return false;
            });
        };

        bindOnce = function () {
        };

        buildFilterTags = ($e, tags) => {
            $.each(tags, function (k, v) {
                $e.append(
                    $('<li class="list-inline-item tag closable"/>').append($('<span class="tag-name" />').attr('data-id', k).html(v).append($('<span class="close"/>').append($('<i class="fas fa-times" />'))))
                );
            });
        }
    };

    $.resultFilter = function (options) {
        return new ResultFilter(null, options);
    };
})(jQuery);

